import {
  Box,
  Button,
  Heading,
  Text,
} from '@chakra-ui/react';
import { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { sec } from '../../Services/vulcan';
import { useAcceptOrgInviteMutation, useGetOrgMeQuery } from '../../Services/orgApi';

const AcceptInvitePage = () => {
  const [params] = useSearchParams();
  const [accepted, setAccepted] = useState(false);
  const user = useSelector((s) => s.account.user);

  const accountId = params.get('account') || '';
  const token = params.get('token') || '';

  const [acceptInvite, state] = useAcceptOrgInviteMutation();
  const { data: orgMe } = useGetOrgMeQuery(undefined, { skip: !user });

  const organizationLabel = useMemo(() => {
    if (!accountId) return '-';
    const row = orgMe?.organizationAccounts?.find((o) => o.accountId === accountId);
    return row?.name ?? accountId;
  }, [accountId, orgMe?.organizationAccounts]);

  const canAccept = useMemo(() => !!accountId && !!token, [accountId, token]);

  const onAccept = async () => {
    sec.setAccount(accountId);
    window.localStorage.setItem('submize_account', accountId);
    await acceptInvite({ accountId, token }).unwrap();
    setAccepted(true);
  };

  return (
    <Box p="24px">
      <Heading size="md" mb="12px">Accept invitation</Heading>
      <Text mb="16px" opacity={0.8}>
        Organization:
        {' '}
        <b>{organizationLabel}</b>
      </Text>
      <Button
        onClick={onAccept}
        isDisabled={!canAccept || accepted}
        isLoading={state.isLoading}
      >
        {accepted ? 'Accepted' : 'Accept'}
      </Button>
      {state.error && (
        <Text mt="12px" color="red.400">
          Error accepting invite.
        </Text>
      )}
    </Box>
  );
};

export default AcceptInvitePage;
